import React, { Component } from "react";
import { DragLayer } from "react-dnd";
import { DragTypes } from "./utilService";

//拖拽的layer组件类
class CustomDragLayer extends Component {
    
    //如果是item类型，返回preview组件
    renderItem(type, item) {
        switch (type) {
            case DragTypes.GROUP_ITEM:
                if (item.group) {
                    return this.props.previewCom(item.group);
                } else {
                    return null;
                }

            default:
                return null;
        }
    }

    getItemStyles = () => {
        const { initialOffset, currentOffset } = this.props;
        if (!initialOffset || !currentOffset) {
            return { display: 'none' };
        }
        let { x, y } = currentOffset;
        x -= initialOffset.x;
        y -= initialOffset.y;
        x += initialOffset.x;
        y += initialOffset.y;
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform,
            WebkitTransform: transform,
        };
    }
    
    render() {
        const { item, itemType, isDragging } = this.props;
        if (!isDragging || itemType !== DragTypes.GROUP_ITEM) {
            return null;
        }
        //IE浏览器去掉拖拽预览
        if (
            navigator.userAgent.indexOf("MSIE") > -1 ||
            navigator.userAgent.indexOf("Trident") > -1 ||
            navigator.userAgent.indexOf("Edge") > -1
        ) {
            return null;
        }
        return (
            <div className="group-item-layer">
                <div style={this.getItemStyles()}>{this.renderItem(itemType, item)}</div>
            </div>
        );
    }
}
CustomDragLayer = DragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    clientOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
}))(CustomDragLayer);
export default CustomDragLayer;
